(ns core.db.child-entity
  (:require #?(:clj [core.db.child-entity-query :as child-query])
            [core.db.entity.util :as eu]))

(defn fallback-child-entities-fn [entity-type]
  (comp (partial filter (eu/is-type-fn entity-type))
        :entity/_parent))

(defn child-entities-of-type-fn
  "Make a handler for querying all entities of specific type which are
  children of given entity.

  Returns a function parent -> [entity]"
  [entity-type]
  (let [fallback (fallback-child-entities-fn entity-type)]
    #?(:clj (child-query/make-child-entities-of-type-fn entity-type fallback)
       :cljs fallback)))

(defn child-entity-of-type-fn
  "Make a handler for querying a single child of given type"
  [entity-type]
  (let [fallback (comp first (fallback-child-entities-fn entity-type))]
    #?(:clj (child-query/make-child-entity-of-type-fn entity-type fallback)
       :cljs fallback)))
